import { createAction, props } from '@ngrx/store'

// Theme
export const dark_theme = createAction('Dark theme')
export const light_theme = createAction('Light theme')
export const paper_theme = createAction('Paper theme')

// User
export const username = createAction('User name')
export const email = createAction('Email', props<{ value: string }>())
export const activision_code = createAction('Activision_Code', props<{ value: string }>())

//Page
export const home = createAction('Home page')
export const admin = createAction('Admin page')
export const search = createAction('Search page')
export const library = createAction('Library page')
export const network = createAction('Network page')
export const notifications = createAction('Notifications page')
export const add = createAction('Add page')
export const store = createAction('Store page')
export const signup = createAction('Signup page')
export const login = createAction('Login page')
export const verification = createAction('Verification page')
